import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import alTranslations from "./al";
import enTranslations from "./en";
import itTranslations from "./it";

const lang = localStorage.getItem('lang');
if (lang !== 'en' && lang !== 'al' && lang !== 'it') {
  localStorage.setItem('lang', 'al');
}

const language = localStorage.getItem('lang')

const resources = {
  en: {
    translation: enTranslations
  },
  al: {
    translation: alTranslations
  },
  it: {
    translation: itTranslations
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: language,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
